import { Pdf } from "@/crossPlatform/Pdf";
import useAppMonitor from "@/services/AppMonitor";
import type { PdfViewerModalProps } from "@/ui/composed/media/pdfViewer/types";

const PdfViewerModal = ({ isOpen, onClose, uri }: PdfViewerModalProps) => {
  const { captureException } = useAppMonitor();
  if (!isOpen) {
    return null;
  }

  return (
    <Pdf
      onError={(error) => {
        captureException(new Error("Error loading PDF", { cause: error }));
      }}
      // once PDF is opened in a new tab, mark this modal "closed" so subsequent presses can open subsequent new tabs
      onLoadComplete={onClose}
      source={{ uri }}
    />
  );
};

export default PdfViewerModal;
